import React, { useState } from "react";
import { ChevronDown, Check } from "lucide-react";
import { SERVICES } from "@/data/services";

export default function ServicesAccordion() {
  const [open, setOpen] = useState(null);

  return (
    <section
      id="services"
      data-testid="services-accordion"
      className="relative py-24 lg:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#F5C518] font-bold mb-3">
            // Services
          </div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl uppercase tracking-tighter leading-[0.95]">
            Everything your vehicle <br />
            <span className="text-[#F5C518]">deserves.</span>
          </h2>
          <p className="mt-4 text-neutral-400 text-base max-w-lg leading-relaxed">
            Ten core service categories — every job handled in-house by certified technicians using OEM-grade tools.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            const isOpen = open === s.id;
            return (
              <button
                key={s.id}
                data-testid={`service-card-${s.id}`}
                onClick={() => setOpen(isOpen ? null : s.id)}
                className={`text-left rounded-xl border transition-all duration-300 overflow-hidden ${
                  isOpen
                    ? "border-[#F5C518] bg-[#F5C518]/5 shadow-[0_0_30px_rgba(245,197,24,0.15)]"
                    : "border-white/8 bg-white/[0.02] hover:border-white/20"
                }`}
              >
                <div className="p-6 flex items-start gap-4">
                  <div
                    className={`w-11 h-11 shrink-0 rounded-lg flex items-center justify-center transition-colors ${
                      isOpen ? "bg-[#F5C518] text-[#121212]" : "bg-white/5 text-[#F5C518]"
                    }`}
                  >
                    <Icon className="w-5 h-5" strokeWidth={2} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-3">
                      <h3 className="font-display font-bold text-base sm:text-lg uppercase tracking-tight">
                        {s.title}
                      </h3>
                      <ChevronDown
                        className={`w-5 h-5 shrink-0 text-neutral-400 transition-transform ${
                          isOpen ? "rotate-180 text-[#F5C518]" : ""
                        }`}
                      />
                    </div>
                    <p className="mt-1.5 text-sm text-neutral-400 leading-relaxed">
                      {s.description}
                    </p>
                  </div>
                </div>
                <div
                  className={`grid transition-all duration-300 ${
                    isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-6 pb-6 pt-1 border-t border-white/8">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-4">
                        {s.sub.map((item) => (
                          <div
                            key={item}
                            className="flex items-start gap-2 text-sm text-neutral-300"
                          >
                            <Check className="w-3.5 h-3.5 text-[#F5C518] mt-0.5 shrink-0" strokeWidth={3} />
                            <span>{item}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
